import type { StepperDesignTokens, StepperTokenSections } from '@openng/optimus-ui-themes/types/stepper';

export const separator: StepperTokenSections.Separator = {
	background: '{surface.400}',
};

export const stepTitle: StepperTokenSections.StepTitle = {
	color: '{primary.200}',
	fontWeight: '600',
};

export const stepNumber: StepperTokenSections.StepNumber = {
	borderColor: '{primary.200}',
	activeBorderColor: '{primary.color}',
	color: '{primary.200}',
	size: '1.5rem',
	fontSize: '0.8rem',
};

export default {
	separator,
	stepTitle,
	stepNumber,
} satisfies StepperDesignTokens;
